import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, NgZone } from '@angular/core'
import { AssetMini, AssetMiniFromJSON, MediaRootMini } from 'elements-sdk'

@Component({
  selector: 'seekable-thumbnail',
  templateUrl: './seekableThumbnail.component.pug',
  styleUrls: ['./seekableThumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeekableThumbnailComponent {
  @Input() asset: AssetMini
  @Input() time?: number
  @Input() root?: MediaRootMini
  @Input() seeking = false

  private initialTime = 0

  constructor (
    private elementRef: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
  ) { }

  ngAfterViewInit () {
    const addEventListener = window[window['Zone'].__symbol__('addEventListener')] as any

    addEventListener.bind(this.elementRef.nativeElement)('mousemove', event => {
      if (this.elementRef.nativeElement.closest('.ui-draggable-dragging')) {
        return
      }
      this.seeking = true
      const dx = event.pageX - this.elementRef.nativeElement.getBoundingClientRect().left
      const ts = this.asset.format.duration! * dx / this.elementRef.nativeElement.clientWidth
      this.time = ts
      this.zone.run(() => this.cdr.markForCheck())
    }, { passive: true })

    addEventListener.bind(this.elementRef.nativeElement)('mouseleave', () => {
      this.seeking = false
      this.time = this.initialTime
      this.zone.run(() => this.cdr.markForCheck())
    }, { passive: true })
  }

  ngOnChanges () {
    if ('default_proxy' in this.asset) {
      this.asset = AssetMiniFromJSON(this.asset)
      if (this.asset.type !== 'video' && this.asset.type !== 'audio') {
        throw new Error('Asset is neither a video nor an audio')
      }
    }
  }

  ngOnInit () {
    if (this.time === undefined && this.asset.type === 'video') {
      this.time = this.asset.format.duration! / 10
    }
    this.time ??= 0
    this.initialTime = this.time
    if (this.root?.prefetchThumbnailStrips ?? true) {
      new Image().src = this.asset.defaultProxy?.urls.strip ?? ''
    }
  }
}
